import { addressInfoDisplayStyles } from "@insite/content-library/Components/AddressInfoDisplay";
import { orderTotalDisplayStyles } from "@insite/content-library/Components/OrderTotalDisplay";
import { productBrandStyles } from "@insite/content-library/Components/ProductBrand";
import { orderDateStyles } from "@insite/content-library/Widgets/OrderDetails/OrderDate";
import { billingAddressStyles } from "@insite/content-library/Widgets/OrderDetails/OrderDetailsBillingAddress";
import { shippingAddressStyles } from "@insite/content-library/Widgets/OrderDetails/OrderDetailsShippingAddress";
import { statusStyles } from "@insite/content-library/Widgets/OrderDetails/OrderDetailsStatus";
import { titleStyles } from "@insite/content-library/Widgets/OrderDetails/OrderDetailsTitle";
import { BaseTheme } from "@insite/mobius/globals/baseTheme";
import { breakpointMediaQueries } from "@insite/mobius/utilities";
import getColor from "@insite/mobius/utilities/getColor";
import { css } from "styled-components";

orderTotalDisplayStyles.container = {
    gap: 10,
    css: css`
            background-color: ${getColor("common.accent")};
            padding: 20px;
            div[class^="GridItemStyle"]{
                padding: 0 !important;
            }
            /* EC-690 : Order Details print feature : Resizing this block to fix the layout issue in print mode  */
            @media print{
                padding-top: 8px;
            }
        `,
};
orderTotalDisplayStyles.subtotalLabel = {
    css: css`
    font-size: 14px;
    `,
};
orderTotalDisplayStyles.subtotalValue = {
    css: css`
        font-size: 14px;
            margin-left: auto;
        `,
}

    orderTotalDisplayStyles.discountsValueGridItem = {
        css: css`
        font-size: 14px;
            @media print {
                text-align: right;
            }
        `,
        width: 6,
    }
    orderTotalDisplayStyles.discountsValue = {
        css: css`
        font-size: 14px;
            margin-left: auto;
        `,
    }
    orderTotalDisplayStyles.shippingAndHandlingLabel = {
        css: css`
font-size: 14px;
`,
    }
    orderTotalDisplayStyles.shippingAndHandlingValue = {
        css: css`
        font-size: 14px;
            margin-left: auto;
        `,
    }
    orderTotalDisplayStyles.otherChargesLabel = {
        css: css`
        font-size: 14px;
        `,
    }
    orderTotalDisplayStyles.otherChargesValue = {
        css: css`
        font-size: 14px;
            margin-left: auto;
        `,
    }
    orderTotalDisplayStyles.taxLabel = {
        css: css`
        font-size: 14px;
   
        `,
    }
    orderTotalDisplayStyles.taxValue = {
        css: css`
        font-size: 14px;
            margin-left: auto;

        `,
    }
    orderTotalDisplayStyles.totalLabel = {
        css: css`
    font-size: 16px;
    margin-bottom: 0px;
    ${({ theme }: { theme: BaseTheme }) =>
            breakpointMediaQueries(theme, [
                css`
font-size: 14px;
                `,
                css`
                font-size: 14px;
                `,
                css``,
                css``,
                css``,
            ])}
    `,
        weight: "bold"
    }
    orderTotalDisplayStyles.totalValue ={
        weight: "bold",
        css: css`
        font-size: 16px;
            margin-left: auto;
            margin-bottom: 0px;
            ${({ theme }: { theme: BaseTheme }) =>
            breakpointMediaQueries(theme, [
                css`
font-size: 14px;
                `,
                css`
                font-size: 14px;
                `,
                css``,
                css``,
                css``,
            ])}
        `,
    }
    orderDateStyles.wrapper = {
        css: css`
            padding: 10px;
            display: flex;
    flex-direction: column;
    justify-content: center;
    align-items: center;
    /* EC-690 : Order Details print feature : Resizing this block to fix the layout issue in print mode  */
    @media print {
        padding: 0;
    }
        `,
    }
    orderDateStyles.orderDate = {
        css:css`
        font-size: 16px;
font-style: normal;
font-weight:500;
/* margin-bottom: 5px; */ /* Commenting this code to fix the layout of the title */

${({ theme }: { theme: BaseTheme }) =>
            breakpointMediaQueries(theme, [
                css`
font-size: 12px;
margin-bottom: 0px;

                `,
                css`
                font-size: 12px;
                margin-bottom: 0px;

                `,
                css``,
                css``,
                css``,
            ])}
        `,
    }
    orderDateStyles.titleText = {
        variant: "h3",
        css: css`
            @media print {
                font-size: 12px;
            }
            /* margin-bottom: 5px; */ /* Commenting this code to fix the layout of the title */
            text-align: center;
            text-transform: uppercase;
    font-weight: 400;
font-size: 14px;
margin-bottom: 0px;

${({ theme }: { theme: BaseTheme }) =>
            breakpointMediaQueries(theme, [
                css`
font-size: 12px;
                `,
                css`
                font-size: 12px;
                `,
                css``,
                css``,
                css``,
            ])}
        `,
    }
    billingAddressStyles.wrapper = {
        css: css`
            padding: 5px 24px;
            padding-bottom: 20px;
            width: 100%;     
            height:100%;
            ${({ theme }: { theme: BaseTheme }) =>
                breakpointMediaQueries(theme, [
                    css`
                    padding: 5px 14px;
             `,
                    css`
                    padding: 5px 14px;
               `,
                    css``,
                    css``,
                    css``,
                ])}   `,
    }
    shippingAddressStyles.wrapper= {
        css: css`
            padding: 5px 24px;
            padding-bottom: 10px;
            width: 100%;
            height:100%;
            ${({ theme }: { theme: BaseTheme }) =>
                breakpointMediaQueries(theme, [
                    css`
                    padding: 5px 14px;
             `,
                    css`
                    padding: 5px 14px;
               `,
                    css``,
                    css``,
                    css``,
                ])}
        `,
    }
    statusStyles.status = {
        css:css`
        font-size: 16px;
font-style: normal;
font-weight:500;
        `,
    }
    statusStyles.titleText = {
        variant: "h3",
        css: css`
            @media print {
                font-size: 12px;
            }
            margin-bottom: 0px; /* Updated margin to fix the layout of the title */
            text-align: center;
            text-transform: uppercase;
    font-weight: 400;
font-size: 14px;
${({ theme }: { theme: BaseTheme }) =>
            breakpointMediaQueries(theme, [
                css`
font-size: 12px;
margin-bottom: 0px;

                `,
                css`
                font-size: 12px;
                margin-bottom: 0px;

                `,
                css``,
                css``,
                css``,
            ])}
        `,
    }
    addressInfoDisplayStyles.wrapper = {
        css: css`
            font-style: normal;
            font-size: 14px;
        `,
    }
    productBrandStyles.nameText = {
        css: css`
            width: 100%;
            span{
                font-size: 16px;

            }
            font-size: 16px;

        `,
    };
    productBrandStyles.nameLink = {
        css: css`
            width: 100%;
            span{
                font-size: 16px;

            }
            font-size: 16px;
            typographyProps: nameText,
        `,
    }

    /* EC-690 : Order Details print feature : Removing margin to fix the layout issue in print mode  */
    titleStyles.titleText = {
        variant: "h2",
        as: "h1",
        css: css`
            margin-bottom: 0 !important;
        `
    }